module.exports = "/img/2.395cf2be.png";